import type { TProductivityGoalMetric } from './types';

export const clampPercent = (value: number) =>
  Math.max(0, Math.min(100, value));

export const formatPercent = (value?: number, fallback = '--'): string =>
  typeof value === 'number' && Number.isFinite(value)
    ? `${clampPercent(value)}%`
    : fallback;

export const sanitizeMetrics = (
  metrics?: Array<TProductivityGoalMetric | null | undefined>,
): TProductivityGoalMetric[] =>
  metrics?.filter((metric): metric is TProductivityGoalMetric =>
    Boolean(metric),
  ) ?? [];

export const buildMarkerList = (
  markers: TProductivityGoalMetric['markers'],
  targetPercent?: number,
  targetLabel?: string,
) => {
  const baseMarkers = markers?.filter((marker) =>
    Number.isFinite(marker?.percent),
  );

  if (typeof targetPercent === 'number') {
    return [
      ...(baseMarkers ?? []),
      {
        percent: clampPercent(targetPercent),
        label: targetLabel,
        emphasis: 'strong' as const,
      },
    ];
  }

  return baseMarkers ?? [];
};

export const metricDisplayValue = (metric: TProductivityGoalMetric) =>
  metric.valueDisplay ?? formatPercent(metric.percent);
